
// SVG Icon: view-story
export default { id: "terriajs-view-story" };
export const id = "terriajs-view-story";
export const name = "view-story";
